import { Box, Stack } from '@mui/material';
import { EdlStrengthSlider } from '@/components/shared/EdlStrengthSlider';
import * as state from './state';
import * as globalState from '@/state';
import { PointLabels } from './PointLabels';
import { ZoneSelector } from './ZoneSelector';
import { VisibilityBoxPanel } from './VisibilityBoxPanel';
import { PointSizeControls } from '../shared/PointSizeControls';
import { RgbBlendLevelSlider } from '../shared/RgbBlendLevelSlider';
import { CuboidClassesVisibility } from './CuboidClassesVisibility';
import { ToggleItemVisibility } from '../Analysis/Viewer/Panels/Visibility/ToggleItemVisibility';
import { useAtom, useAtomValue } from 'jotai';

export const LeftToolbar = () => {
  const [showViewpoints, setShowViewpoints] = useAtom(state.showViewpoints);
  const selectedZone = useAtomValue(globalState.selectedZone);
  const structure = useAtomValue(state.structure);
  const [showZoneBoundaries, setShowZoneBoundaries] = useAtom(state.showZoneBoundaries);
  const [showNeighbouringZones, setShowNeighbouringZones] = useAtom(
    state.showNeighbouringZones
  );

  return (
    <>
      <ZoneSelector />

      {selectedZone && (
        <Stack sx={{ overflowY: 'auto' }}>
          <Box sx={{ paddingY: 1 }}>
            <VisibilityBoxPanel />
          </Box>
          <Box sx={{ paddingY: 0.5 }}>
            <ToggleItemVisibility
              label="Zone boundaries"
              isVisible={showZoneBoundaries}
              toggleVisibility={() => setShowZoneBoundaries((current) => !current)}
            />
          </Box>
          <Box sx={{ paddingY: 0.5 }}>
            <ToggleItemVisibility
              label="Neighbouring zones"
              isVisible={showNeighbouringZones}
              toggleVisibility={() => setShowNeighbouringZones((current) => !current)}
            />
          </Box>
          <Box sx={{ paddingTop: 0.5, paddingBottom: 1 }}>
            <ToggleItemVisibility
              label="Viewpoints"
              isVisible={showViewpoints}
              toggleVisibility={() => setShowViewpoints((current) => !current)}
            />
          </Box>

          <PointSizeControls />

          <EdlStrengthSlider title="Enhance Points" />

          {structure?.hasRGB && <RgbBlendLevelSlider title="Colour blender" />}

          <PointLabels />

          <CuboidClassesVisibility />

          {/* <FormLabel sx={{ padding: '15px 0px 5px' }}>Cuboids</FormLabel>
          <CuboidsTable /> */}
        </Stack>
      )}
    </>
  );
};
